import React, { useContext, useState } from 'react'
import { Button, DatePicker, Flex, Radio, Select } from 'antd'
import Title from 'antd/es/typography/Title'
import GlobalContext from '../GlobalContext'
import dayjs from 'dayjs'
import { t } from 'i18next'
const { RangePicker } = DatePicker

export default function Selectors ({ setFilter }) {
  const { boxes } = useContext(GlobalContext)
  const [box, setBox] = useState('all')
  const [selectedBoxes, setSelectedBoxes] = useState([])
  const [period, setPeriod] = useState('day')
  const [date, setDate] = useState(dayjs())
  const [range, setRange] = useState([dayjs(), dayjs()])
  const filteredBoxes = boxes.filter(box => !selectedBoxes.includes(box.id))

  const labelRender = props => {
    const { value } = props

    return boxes.find(box => box.id === value).name
  }

  const updateFilter = () => {
    const newFilter = {}
    if (period === 'day') {
      newFilter.start_date = date.startOf('day').format('YYYY-MM-DD HH:mm:ss')
      newFilter.end_date = date.endOf('day').format('YYYY-MM-DD HH:mm:ss')
    } else {
      newFilter.start_date = range[0].startOf('day').format('YYYY-MM-DD HH:mm:ss')
      newFilter.end_date = range[1].endOf('day').format('YYYY-MM-DD HH:mm:ss')
    }
    if (box === 'all') {
      newFilter.box_ids = boxes.map(box => box.id)
    } else {
      newFilter.box_ids = selectedBoxes
    }
    setFilter(newFilter)
  }

  return (
    <Flex gap='4em' style={{ marginTop: '2em' }}>
      <Flex vertical gap='1em' style={{ width: '15%' }}>
        <Title level={4} style={{ margin: 0 }}>Période</Title>
        <Radio.Group
          block
          onChange={({ target: { value } }) => setPeriod(value)}
          value={period}
          options={[
            { label: 'Journée', value: 'day' },
            { label: 'Période', value: 'range' }
          ]}
          optionType="button"
          buttonStyle="solid"
        />
        {period === 'day' &&
          <DatePicker format={'DD/MM/YYYY'} onChange={setDate} value={date} />
        }
        {period === 'range' &&
          <RangePicker format={'DD/MM/YYYY'} onChange={setRange} value={range} />
        }
      </Flex>
      <Flex vertical gap='1em' style={{ width: '15%' }}>
        <Title level={4} style={{ margin: 0 }}>Box</Title>
        <Radio.Group
          block
          onChange={({ target: { value } }) => setBox(value)}
          value={box}
          options={[
            { label: 'Sélection', value: 'selected' },
            { label: 'Toutes', value: 'all' }
          ]}
          optionType="button"
          buttonStyle="solid"
        />
        {box === 'selected' &&
          <Select
            mode='multiple'
            allowClear
            options={filteredBoxes.map((box) => ({ label: box.name, value: box.id }))}
            value={selectedBoxes}
            onChange={setSelectedBoxes}
            showSearch={{
              optionFilterProp: 'label',
              filterSort: (optionA, optionB) =>
                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
            }}
            style={{ width: '100%' }}
            placeholder='Sélectionnez une box'
            labelRender={labelRender}
          />
        }
      </Flex>
      <Button onClick={updateFilter} type='primary' style={{ margin: '3em' }}>{t('actions.search')}</Button>
    </Flex>
  )
}
